import { createGlobalStyle } from "styled-components";
import baseTheme from "../themes/baseTheme";
import { reducedMotion } from "./device";

export default createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    /* Kept in sync with the sticky header's rendered height so anchor
     * links land with the section title clear of the bar. */
    --sticky-header-h: 96px;
    scroll-behavior: smooth;
    scroll-padding-top: calc(var(--sticky-header-h) + 16px);
    /* "clip", not "hidden": hidden pairs its opposite axis to "auto",
     * which turns html/body into scroll containers and breaks
     * position: sticky for the header. clip has no such side effect. */
    overflow-x: clip;
    /* Reserves the scrollbar's width permanently, so toggling it off while
     * the mobile menu / demo dialog locks scroll (useScrollLock) never
     * shifts the page horizontally. */
    scrollbar-gutter: stable;
  }

  body {
    background: ${baseTheme.colors.white};
    color: ${baseTheme.colors.brand.ink};
    font-family: ${baseTheme.typography.fonts.body};
    font-size: ${baseTheme.typography.rootFontSize};
    line-height: 1.65;
    margin: 0;
    overflow-x: clip;
    -webkit-font-smoothing: antialiased;
  }

  a,
  button {
    -webkit-tap-highlight-color: transparent;
  }

  a:focus-visible,
  button:focus-visible,
  summary:focus-visible {
    outline: 3px solid ${baseTheme.colors.brand.pink};
    outline-offset: 5px;
  }

  @media ${reducedMotion} {
    html {
      scroll-behavior: auto;
    }

    *,
    *::before,
    *::after {
      animation: none !important;
      transition: none !important;
    }
  }
`;
